import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Button } from '../layout';

const MaintenancePage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Il sistema è attualmente in manutenzione. Riprova più tardi.');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchMaintenanceMessage();
    }, []);

    const fetchMaintenanceMessage = async () => {
        try {
            setIsLoading(true);
            const response = await api.getMaintenanceStatus();
            if (response.status === 'success' && response.maintenance) {
                setMessage(response.maintenance.message);
            }
        } catch (error) {
            console.error('Error fetching maintenance message:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // If user is admin, show a button to bypass maintenance mode
    const isAdmin = user && user.role === 'admin';

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
                <div className="mb-6">
                    <svg
                        className="w-16 h-16 mx-auto text-yellow-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                    </svg>
                </div>

                <h1 className="text-2xl font-bold text-gray-800 mb-4">Manutenzione in Corso</h1>

                {isLoading ? (
                    <div className="flex justify-center items-center h-12">
                        <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-red-500"></div>
                    </div>
                ) : (
                    <p className="text-gray-600 mb-8">{message}</p>
                )}

                <div className="flex flex-col space-y-4">
                    {isAdmin && (
                        <>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => navigate('/dashboard')}
                                fullWidth
                            >
                                Accedi come Amministratore
                            </Button>

                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => navigate('/maintenance')}
                                fullWidth
                            >
                                Gestisci Modalità Manutenzione
                            </Button>
                        </>
                    )}

                    {!isAdmin && (
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => window.location.href = "/"}
                            fullWidth
                        >
                            Riprova
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;